import { render } from "./UserProfileCommentsSection.vue?vue&type=template&id=6d3797ce"
import script from "./UserProfileCommentsSection.vue?vue&type=script&lang=js"
export * from "./UserProfileCommentsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__